<template>
    <div v-if="list">
        <Modal title="操作日志" :value="value" @on-visible-change="visibleChange" :mask-closable="false" width="500">
            <Timeline class="cont">
                <TimelineItem v-for="item in list" :key="item.id">
                    <div>
                        <span class="log-name">{{ item.creatorName }}</span>
                        {{ item.creationTimeText }}
                    </div>
                    <div>{{ item.content }} {{ item.description ? ',' + item.description : '' }}</div>
                    <div class="jump" v-if="item.content.includes('修改') || item.content.includes('批量')" @click="skip(item.id)">点击查看编辑详情</div>
                </TimelineItem>
            </Timeline>
            <div slot="footer">
                <Button @click="close" class="close-btn">关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            list: [],
        };
    },
    props: {
        value: Boolean,
        id: Number,
    },
    mounted() {
        this.getInitData();
    },
    methods: {
        async getInitData() {
            this.$Spin.show();
            const data = await this.$Ajax(`/api/services/app/BOMImportRecord/Get?id=${this.id}`);
            this.list = data.data.result.businessLogDtos;
            this.$Spin.hide();
        },
        skip(cid) {
            // this.id //这个是哪个bOMImportRecordId
            // cid //是businessLogId
            // debugger
            this.$emit('open-excel', this.id, cid);
        },
        close() {
            this.$emit('close-modal', false);
        },
        visibleChange(value) {
            //这里value都为false
            if (!false) {
                this.$emit('close-modal', value);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.cont {
    min-height: 200px;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
}
.cont::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}

/deep/.ivu-modal-header-inner {
    font-size: 20px;
    text-align: center;
}

.jump {
    cursor: pointer;
}

.log-name {
    font-weight: 700;
    margin-right: 10px;
}

/deep/.ivu-modal-footer {
    text-align: center;
}
</style>
